<template>
  <v-container fluid class="pa-6">
    <v-row align="center" class="mb-4">
      <v-col cols="12" md="6">
        <h1 
          class="text-h4 font-weight-bold"
          style="color: #1976d2"
        >
          <v-icon
            large
            color="primary"
            class="mr-2"
          >
            mdi-account-group
          </v-icon>
          Gestión de Usuarios
        </h1>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="search"
          label="Buscar usuario..."
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          density="comfortable"
          hide-details
          clearable
          @keyup.enter="page = 1; loadUsers()"
          @click:clear="search = ''; page = 1; loadUsers()"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-select
          v-model="filtroRol"
          :items="opcionesRol"
          item-title="label"
          item-value="value"
          label="Filtrar por rol"
          variant="outlined"
          density="comfortable"
          hide-details
          @update:model-value="page = 1; loadUsers()"
        />
      </v-col>
      <v-col cols="12" md="3" class="d-flex justify-end">
        <v-pagination
          v-model="page" 
          :length="totalPages"
          :total-visible="5"
          density="comfortable"
          active-color="primary"
          @update:model-value="loadUsers"
        />
      </v-col>
    </v-row>

    <v-card elevation="2" class="rounded-lg">
      <v-table hover>
        <thead class="bg-blue text-white">
          <tr>
            <th class="text-white">ID</th>
            <th class="text-white">Usuario</th>
            <th class="text-white">Nombre Completo</th>
            <th class="text-white">Correo</th>
            <th class="text-white">Rol</th>
            <th class="text-white text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.idUser">
            <td class="font-weight-bold">#{{ user.idUser }}</td>
            <td><v-chip size="small" variant="outlined" color="primary">{{ user.user }}</v-chip></td>
            <td>{{ user.name }} {{ user.surNames }}</td>
            <td>{{ user.email }}</td>
            <td>
              <v-chip :color="user.role === 'administrador' ? 'red-darken-2' : 'green-darken-1'" size="small" class="text-uppercase">
                {{ user.role }}
              </v-chip>
            </td>
            <td class="text-center">
              <v-btn icon="mdi-pencil" variant="text" color="blue" size="small" @click="openEditModal(user)"></v-btn>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>

    <v-row class="mt-6">
      <v-col cols="12" class="d-flex justify-center">
        <v-pagination v-model="page" :length="totalPages" :total-visible="7" active-color="green" @update:model-value="loadUsers"></v-pagination>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card class="rounded-lg">
        <v-toolbar color="primary" title="Editar Usuario" density="compact">
          <v-btn icon="mdi-close" @click="dialog = false"></v-btn>
        </v-toolbar>
        
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedUser.user" label="Nombre de Usuario" variant="outlined" density="comfortable"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select v-model="editedUser.role" :items="['administrador', 'usuario', 'invitado']" label="Rol de Sistema" variant="outlined" density="comfortable"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedUser.name" label="Nombres" variant="outlined" density="comfortable"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedUser.surNames" label="Apellidos" variant="outlined" density="comfortable"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="editedUser.email" label="Correo Electrónico" variant="outlined" density="comfortable" type="email"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedUser.phoneNumber" label="Teléfono" variant="outlined" density="comfortable"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedUser.age" label="Edad" variant="outlined" density="comfortable" type="number"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey-darken-1" variant="text" @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" variant="elevated" :loading="loading" @click="saveUser">Guardar Cambios</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000">
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import apisUsers from '@/apis/apisUsers';

export default {
  name: 'UsersView',
  props: ['query'], 
  data() {
    return {
      users: [],
      search: this.query || "",
      filtroRol: "",
      opcionesRol: [
        { label: "Todos", value: "" },
        { label: "Administrador", value: "administrador" },
        { label: "Usuario", value: "usuario" }
      ],
      page: 1,
      totalPages: 0,
      totalElements: 0,
      // Estados del modal
      dialog: false,
      loading: false,
      editedUser: {},
      snackbar: { show: false, text: '', color: '' }
    };
  },
  watch: {
    '$route.params.query': function(newQuery) {
      this.search = newQuery || "";
      this.page = 1;
      this.loadUsers();
    }
  },
  mounted() {
    this.loadUsers();
  },
  methods: {
    loadUsers() {
      const pageIndex = this.page - 1;
      apisUsers.searchUsers(this.search, pageIndex, "", "", this.filtroRol)
        .then((response) => {
          this.users = response.content;
          this.totalPages = response.totalPages;
          this.totalElements = response.totalElements;
        });
    },
    openEditModal(user) {
      // Creamos una copia profunda para no editar la fila de la tabla directamente
      this.editedUser = JSON.parse(JSON.stringify(user));
      this.dialog = true;
    },
    saveUser() {
      this.loading = true;
      // Usamos el método updateUser de tu archivo de apis
      apisUsers.updateUser(this.editedUser)
        .then(() => {
          this.showNotify("Usuario actualizado con éxito", "success");
          this.dialog = false;
          this.loadUsers(); // Recargamos la tabla
        })
        .catch((error) => {
          this.showNotify(error.message, "error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showNotify(text, color) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    }
  }
};
</script>